export enum MasterCode {
  Timezone = 'Timezone',
  DateFormatTypes = 'DateFormatTypes',
  Status = 'Status',
  GroupPermits = 'GroupPermits',
  Roles = 'Roles',
  Company = 'Company',
  ContactFlag = 'ContactFlag',
  ContactPreference = 'ContactPreference',
  InactiveStatus = 'InactiveStatus',
  CancelStatus = 'CancelStatus',
  Currency = 'Currency',
  CountryCode = 'CountryCode',
  LanguageCode = 'LanguageCode',
  Channel = 'Channel',
  ProcessType = 'ProcessType',
  ServiceType = 'ServiceType',
  WarrantyTerm = 'WarrantyTerm',
  ProductCategory = 'ProductCategory',
  ProductType = 'ProductType',
  PaymentType = 'PaymentType',
  InteractiveBound = 'InteractiveBound',
  InteractiveCode = 'InteractiveCode',
  InteractivePartner = 'InteractivePartner',
  DetailType = 'DetailType',
  ProductCategories = 'ProductCategories',
  UserTypes = 'UserTypes',
  UserStatus = 'UserStatus',
  DealerStatus = 'DealerStatus',
  DealerRequestStatus = 'DealerRequestStatus',
  DealerBpTypes = 'DealerBpTypes',
  ConcealedDamageStatus = 'ConcealedDamageStatus',
  ConcealedDamageReportTypes = 'ConcealedDamageReportTypes',
  ConcealedDamageReasons = 'ConcealedDamageReasons',
  ConcealedDamageSubReasons = 'ConcealedDamageSubReasons',
  ConcealedDamagePackages = 'ConcealedDamagePackages',
  ConcealedDamageAppearances = 'ConcealedDamageAppearances',
  ConcealedDamageAccessories = 'ConcealedDamageAccessories',
  ConcealedDamageDefectDetails = 'ConcealedDamageDefectDetails',
  ConcealedDamageRejectReasons = 'ConcealedDamageRejectReasons',
  ConcealedDamageApprovalReasons = 'ConcealedDamageApprovalReasons',
  CDDefectDetails = 'CDDefectDetails',
  SSDefectDetails = 'SSDefectDetails',
  CDRejectReasons = 'CDRejectReasons',
  SSRejectReasons = 'SSRejectReasons',
  ConcealedDamageTypes = 'ConcealedDamageTypes',
  DealerPortalServiceTypes = 'DealerPortalServiceTypes',
  SecaStatuss = 'SecaStatus',
  ConcealedDamageProductType = 'ConcealedDamageProductType',
  B2bWorkFlowStatus = 'B2bWorkFlowStatus',
  B2bCaseStatus = 'B2bCaseStatus',
  B2bexchangeStatus = 'B2bExchangeStatus',
  B2bExchangeReason = 'B2bExchangeReason',
  B2bDeliveryType = 'B2bDeliveryType',
  B2bExchangeOption = 'B2bExchangeOption',
  B2bExchangeType = 'B2bExchangeType',
  B2bTicketStatusCode = 'B2bTicketStatusCode',
  B2bRoles = 'B2bRoles',
  B2bPartner = 'B2bPartner',
  B2bZipcodePartners = 'B2bZipcodePartners',
  B2bInteractionChannel = 'B2bInteractionChannel',
  B2bInteractionPartner = 'B2bInteractionPartner',
  B2bInteractionCategory = 'B2bInteractionCategory',
  B2bInteractionTextType = 'B2bInteractionTextType',
  B2bInquiryTypes = 'B2bInquiryTypes',
  B2bInquiryStatuses = 'B2bInquiryStatuses',

  B2bShippingCompanies = 'B2bShippingCompanies',
  B2BDashBoardCondition = 'B2BDashBoardCondition',
  B2bIncoterms = 'B2bIncoterms',
  B2bShippingSpeeds = 'B2bShippingSpeeds',
  B2bRMAChangeReason = 'B2bRMAChangeReason',
  B2BExchangeSubStatus = 'B2BExchangeSubStatus',
  B2BReturnSubStatus = 'B2BReturnSubStatus',
  B2bRsmVipHandlerList = 'B2bRsmVipHandlerList',
  B2bRsmHandlerNameList = 'B2bRsmHandlerNameList',
  B2bRsmEscalationStatusCodes = 'B2bRsmEscalationStatusCodes',
  B2BProductID = 'B2BProductID',
}
